const dataLanguage = {
    "fr": {
        "first_name": "Prénom",
        "last_name": "Nom de famille",
        "email": "Email",
        "password": "Mot de passe",
        "company-field": "Société",
        "header-field-199ac09fc504c": "Adresse de livraison",
        "address-field": "Nom de rue",
        "city-field": "Ville",
        "country-field": "Pays",
        "phone-field" : "Téléphone" ,
        "header-field-f62b50ba4e994": "Adresse de la société enregistrée",
        "zip-field": "Code postal",
        "address-field" : "Adresse",
        "vat-validation": "Numéro d'enregistrement TVA",
        "city-field" : "Champ de ville", 
        "header-field-aa4914b46678e" : 'informations principales', 
        "header-field-869b62a76913d" : 'détails',
        "privacy-policy": "<p>En cliquant sur Créer, je confirme avoir lu et accepté la politique de confidentialité.</p>"
    }
};


let language = 'en';
if (window.location.pathname.includes("/pages/inscription-professionnels")) {
    language = 'fr';
} 
document.addEventListener("BSS_get_form_success", e => {
BSS_B2B.rf.translations.submit_button = 'Soumettre'
})